import React from "react";
import Navbar from "../components/Navbar";
import HeroSection from "../components/HeroSection";
import ProductsSection from "../components/ProductsSection";
import Footer from "../components/Footer";

const HomePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-brand-bg">
      <Navbar />
      <HeroSection />
      <ProductsSection />
      <Footer />
    </div>
  );
};

export default HomePage;
